import GlnService from '../shared/service/GlnService'
import { IAfleverafspraakGroepKoppeling } from 'shared/models/IAfleverafspraakGroepKoppeling'
import { IAfleverafspraakLocatieKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import {
  IKoppelGroepRequest,
  IPostKoppelRequest,
  IUpdateKoppelingRequest,
} from 'shared/models/PostRequestModel'
import { VestigingEnum } from 'shared/models/Enum'
import { IObjectResponse, IResponse } from 'shared/models/IResponse'
import { IKlant } from 'shared/models/IKlant'
import { IOrderType } from 'shared/models/IOrderType'

export class AflAdrLosseKopersService {
  public async saveGroupLink(
    group: IAfleverafspraakGroepKoppeling,
    customer: IKlant
  ): Promise<IResponse> {
    const request: IKoppelGroepRequest = {
      klantNummer: customer.klantNummer,
      klantAfleverafspraakId: group.klantAfleverAfspraakId,
      koppelingId: group.afleverafspraakGroepKoppelingId,
      groupId: group.klantGroepId,
      orderTypes: group.orderTypes,
      dagen: group.dagen,
      ingangsDatum: group.ingangsDatum,
      eindDatum: group.eindDatum,
    }

    try {
      let result = null
      if (request.koppelingId > 0) {
        result = await GlnService.updateGroepKoppeling(request)
      } else {
        result = await GlnService.postGroepKoppeling(request)
      }

      return result
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij opslaan groepkoppeling: ${e.Message}`,
      }
    }
  }

  public async saveLocationLink(
    link: IAfleverafspraakLocatieKoppeling,
    customer: IKlant
  ): Promise<IResponse> {
    try {
      let result = null
      if (link.afleverafspraakLocatieKoppelingId > 0) {
        const request: IUpdateKoppelingRequest = {
          eindDatum: link.eindDatumtijd,
          ingangsDatum: link.ingangsDatumtijd,
          klantNummer: customer.klantNummer,
          // @ts-expect-error
          // Fix the interface
          locatieGlnId: link.shipToLocationGlnId,
          koppelingId: link.afleverafspraakLocatieKoppelingId,
          combinatie: link.combinatie,
          magCombineren: link.magCombineren,
        }
        result = await GlnService.updateKoppeling(request)
      } else {
        const request: IPostKoppelRequest = {
          eindDatum: link.eindDatumtijd,
          ingangsDatum: link.ingangsDatumtijd,
          klantAfleverafspraakId: link.klantAfleverAfspraakId,
          klantNummer: customer.klantNummer,
          // @ts-expect-error
          // Fix the interface
          locatieGlnId: link.shipToLocationGlnId,
        }
        result = await GlnService.postKoppeling(request)
      }
      return result
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij opslaan locatiekoppeling: ${e.Message}`,
      }
    }
  }

  public async deleteLocationLink(
    warehouse: VestigingEnum,
    customerNumber: number,
    linkId: number
  ): Promise<IResponse> {
    try {
      return await GlnService.postVerwijderKoppeling(
        warehouse.valueOf(),
        customerNumber,
        linkId
      )
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij verwijderen locatiekoppeling: ${e.Message}`,
      }
    }
  }

  public async deleteGroupLink(
    warehouse: VestigingEnum,
    customerNumber: number,
    linkId: number
  ): Promise<IResponse> {
    try {
      return await GlnService.postVerwijderGroepKoppeling(
        warehouse.valueOf(),
        customerNumber,
        linkId
      )
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij verwijderen groepkoppeling: ${e.Message}`,
      }
    }
  }

  public async searchCustomer(
    customerNumber: number,
    agreementReference: string,
    warehouse: VestigingEnum
  ): Promise<IObjectResponse<IKlant>> {
    try {
      return await GlnService.getCustomerDeliveryAgreements(
        customerNumber,
        agreementReference,
        warehouse
      )
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij zoeken klant: ${e.Message}`,
        payLoad: null,
      }
    }
  }

  public async getPossibleOrderTypes(): Promise<IObjectResponse<IOrderType[]>> {
    try {
      return await GlnService.getPossibleOrderTypes()
    } catch (e) {
      return {
        success: false,
        errorMessage: `Fout bij ophalen ordertypes: ${e.Message}`,
        payLoad: null,
      }
    }
  }
}
